module.exports = __webpack_public_path__ + "features-page-roadmap-08880a02d523a3001df4130386024744.jpg";